import React from 'react';
import krydaIcon from '../../assets/kryda-icon.png';
import './AuthLayout.css';

const AuthLayout = ({ children }) => {
  return (
    <div className="auth-layout">
      <div className="auth-card">
        <div className="auth-header">
          <div className="auth-logo-mark">
            <img src={krydaIcon} alt="Kryda Cloud" className="auth-kryda-logo" />
            <span className="auth-logo-text">Vaultize</span>
          </div>
          <span className="auth-subtext">A Kryda Cloud Technologies Product</span>
        </div>

        <div className="auth-card-content">
          {children}
        </div>
      </div>
    </div>
  );
};

export default AuthLayout;
